import type { FC } from 'react';
import type { SequenceNoteLayout } from './layout-sequence';
import { SequenceText } from './SequenceText';
import { MESSAGE_FONT_SIZE, sequenceColors } from './sequence-constants';
import { FontWeight } from '@/theme/typography';
const NOTE_RADIUS = 4;
const NOTE_STROKE_WIDTH = 1;
const NOTE_TEXT_ALIGN = 'center';
interface SequenceNoteProps {
    note: SequenceNoteLayout;
}
export const SequenceNote: FC<SequenceNoteProps> = ({ note }) => {
    return (
      <g>
        <rect x={note.x} y={note.y} width={note.width} height={note.height} rx={NOTE_RADIUS} ry={NOTE_RADIUS} fill={sequenceColors.noteFill} stroke={sequenceColors.noteStroke} strokeWidth={NOTE_STROKE_WIDTH}/>
        <SequenceText x={note.x} y={note.y} width={note.width} height={note.height} content={note.text} size={MESSAGE_FONT_SIZE} weight={FontWeight.Regular} color={sequenceColors.noteText} align={NOTE_TEXT_ALIGN}/>
      </g>
    );
};
